// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__vFTaN","sm":"Divider_sm__1fHIP","lg":"Divider_lg__beTJp"};